import { render, staticRenderFns } from "./ModalPendencyOnboarding.vue?vue&type=template&id=44e313f4&scoped=true&"
import script from "./ModalPendencyOnboarding.vue?vue&type=script&lang=ts&"
export * from "./ModalPendencyOnboarding.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPendencyOnboarding.vue?vue&type=style&index=0&id=44e313f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e313f4",
  null
  
)

export default component.exports